import { MessageState } from 'Modules/Communication/shared/models/Inbox'
import { RootState } from 'shared/store/store'
import { messageStateToInboxSectionEnum } from 'Modules/Communication/shared/util/messageStateHelper'

export const getEmails = (state: RootState) => state.communication.emails

export const getEmailsFilters = (state: RootState) =>
  state.communication.emails.filters

export const getEmailsSection = (state: RootState) =>
  state.communication.emails.filters.queryStatus

export const getEmailsLabel = (state: RootState) =>
  state.communication.emails.filters.labelId

export const getEmailsMarkedForActions = (state: RootState) =>
  state.communication.emails.marked

export const getEmailFromEmailsById = (id: string) => (state: RootState) =>
  getEmails(state)?.data?.result.find((email) => email.id === id)

export const isEmailMarkedForAction = (id: string) => (state: RootState) =>
  state.communication.emails.marked.includes(id)

export const getEmail = (state: RootState) => state.communication.emails.email

export const getCurrentEmail = (state: RootState) =>
  state.communication.emails.email.current

export const getSingleListActionId = (state: RootState) =>
  state.communication.emails.singleListActionId

export const getEmailStatistics = (state: RootState) =>
  state.communication.emails.statistics

export const getJunkMailState = (state: RootState) =>
  state.communication.emails.junkmail

export const getCurrentEmailState =
  (currentId?: string) => (state: RootState) => {
    const email = getEmail(state)
    if (!currentId) return null
    if (!email.current) return null

    const currentState = getEmail(state).data?.state || MessageState.Processed
    return messageStateToInboxSectionEnum(currentState)
  }
